module.exports = __webpack_public_path__ + "img/finished.4e59feee.svg";